import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Breadcrumb, breadcrumbLd } from "@/components/site/Breadcrumb";
import { Faq, faqLd } from "@/components/site/Faq";
import { MaskLine } from "@/components/site/Reveal";
import { useSeo, SITE_URL } from "@/lib/seo";
import { FAQ_GROUPS, FAQ_ALL } from "@/lib/faq";

const crumbs = [{ to: "/", label: "Accueil" }, { to: "/faq-cheveux-afro", label: "FAQ cheveux afro" }];

export default function FaqPage() {
  useSeo({
    title: "FAQ cheveux afro, crépus et nappy : vos questions | Ozentya",
    description: "Les réponses aux questions les plus fréquentes sur les cheveux afro, crépus et nappy : routine, coiffures protectrices, chute de cheveux, pousse, ingrédients, et la marque Ozentya.",
    path: "/faq-cheveux-afro",
    jsonLd: { "@context": "https://schema.org", "@graph": [{ ...faqLd(FAQ_ALL), url: `${SITE_URL}/faq-cheveux-afro`, inLanguage: "fr-FR" }, breadcrumbLd(SITE_URL, crumbs)] },
  });
  return (
    <main data-testid="faq-page" className="mx-auto max-w-[1100px] px-5 pb-32 pt-44 md:px-10">
      <Breadcrumb items={crumbs} />
      <p className="eyebrow mb-6">Questions fréquentes</p>
      <h1 data-testid="faq-title" className="font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl"><MaskLine delay={0.05}>FAQ cheveux afro, crépus et nappy</MaskLine></h1>
      <p className="mt-8 max-w-3xl text-base leading-relaxed text-[var(--parchment)]/85 md:text-lg">
        Les questions que l'on nous pose le plus souvent sur les cheveux texturés, leur entretien et nos soins. Les réponses sont des repères cosmétiques ; pour toute chute importante ou tout problème de cuir chevelu, consultez un médecin ou un dermatologue.
      </p>
      <nav aria-label="Thèmes de la FAQ" className="mt-10 flex flex-wrap gap-2">
        {FAQ_GROUPS.map((g) => (
          <a key={g.id} href={`#${g.id}`} data-testid={`faq-jump-${g.id}`} className="flex h-10 items-center rounded-full border border-[var(--line)] px-5 text-xs uppercase tracking-[0.18em] text-[var(--parchment)]/85 transition-colors hover:border-[var(--gold)] hover:text-[var(--gold-soft)]">{g.title}</a>
        ))}
      </nav>
      {FAQ_GROUPS.map((g) => (
        <div key={g.id} id={g.id} data-testid={`faq-group-${g.id}`} className="scroll-mt-32">
          <Faq items={g.items} title={g.title} id={`faq-${g.id}`} />
          <Link to={g.link.to} data-testid={`faq-group-link-${g.id}`} className="mt-5 inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em] text-[var(--gold-soft)] hover:underline">
            {g.link.label} <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      ))}
    </main>
  );
}
